/**
 * One of the usages of this enum is to call Backend routes in falcor, So be careful when modifing it.
 */

export enum SubscriptionServiceOfferEnum {
    Mastering = 'Mastering',
    Distribution = 'Distribution',
    MasteringAndDistribution = 'MasteringAndDistribution',
    Samples = 'Samples',
}
